






















































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import SectionTuileAnimNav from '@/components/shared/SectionTuileAnimNav.vue'
import { ITuileNav } from '@/models/ui/ITuileNav'
import { ConvertToTuileNav } from '@/models/alo/AloActivity';

@Component({
  name:"Home",
  components: { 
    SectionTuileAnimNav   
  },
})
export default class Home extends Vue {
  
/*  private coursItems = [    
    BebesNageurs,
    SeSauver,
    ApprentissageEnfant,
    PerfectionnementEnfant,
    Aquafitness,
    Aquaphobie,
    ApprentissageAdulte,
    PerfectionnementAdulte
  ]*/

  get coursAdultes(){
    return this.$store.myGetters.activityList.filter(a => !a.acyEnfant).map(a => ConvertToTuileNav(a))        
  }

  get coursEnfants(){
    return this.$store.myGetters.activityList.filter(a => a.acyEnfant).map(a => ConvertToTuileNav(a))        
  }

  created(){        
    this.$store.myActions.ADM_ACTIVITY_ENSURE()
  }

}
